import React from 'react';
import { useReveal } from '../lib/useReveal';
const TOMOS = [{
  num: '1',
  title: 'El Despertar del Canal Reiki',
  emoji: '📘',
  desc: 'El origen, la historia y los principios del Sistema Usui Reiki. Cómo abrir y activar tu canal energético desde el primer día.'
}, {
  num: '2',
  title: 'Chakras y Sanación Energética',
  emoji: '📗',
  desc: 'El sistema completo de chakras y cómo trabajar con ellos. Diagnóstico, equilibrio y sanación energética profunda en cada sesión.'
}, {
  num: '3',
  title: 'Técnicas Profesionales de Reiki',
  emoji: '📙',
  desc: 'Técnicas avanzadas para sesiones profesionales. Posiciones de manos, protocolos y herramientas que separan al practicante del maestro.'
}, {
  num: '4',
  title: 'Símbolos y Reiki a Distancia',
  emoji: '📕',
  desc: 'Los símbolos sagrados del Reiki Nivel II. Técnicas de Reiki a distancia. Cómo trabajar más allá del tiempo y el espacio.'
}, {
  num: '5',
  title: 'Reiki Profesional y Salida Laboral',
  emoji: '📓',
  desc: 'Cómo convertir tu práctica en un negocio real. Precios, clientes, redes sociales y todo lo que necesitás para vivir del Reiki.'
}, {
  num: '6',
  title: 'Maestría Reiki y Expansión Espiritual',
  emoji: '📔',
  desc: 'El camino completo hacia la Maestría. Integración de los tres niveles, profundización espiritual y expansión de la consciencia.'
}];
export function HowItWorksSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#faf5fc] py-12 md:py-16 px-5 sm:px-6 border-t border-[#e8d5f0]" data-id="element-233">
      <div className="container mx-auto max-w-4xl" data-id="element-234">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-235">
          <h2 className="text-3xl md:text-5xl font-bold text-[#3d2a5f] mb-3" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-236">
            🪷 6 TOMOS COMPLETOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-237">
          {TOMOS.map((tomo, idx) => <div key={idx} className="bg-white border border-[#e8d5f0] rounded-xl p-5 sm:p-6 flex flex-col h-full hover:border-[#c9a14d]/50 transition-colors shadow-sm" data-id="element-238">
              <div className="flex items-start gap-3 mb-3" data-id="element-239">
                <span className="text-3xl leading-none" data-id="element-240">{tomo.emoji}</span>
                <div data-id="element-241">
                  <span className="text-[#c9a14d] text-[10px] font-bold tracking-widest uppercase block mb-1" data-id="element-242">
                    Tomo {tomo.num}
                  </span>
                  <h3 className="text-lg font-bold text-[#3d2a5f] leading-tight" data-id="element-243">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <p className="text-[#6b5a85] text-sm leading-relaxed mt-2" data-id="element-244">
                {tomo.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-10 bg-white border border-[#e8d5f0] rounded-xl p-6 text-center max-w-2xl mx-auto shadow-sm" data-id="element-245">
          <p className="text-[#3d2a5f] font-bold mb-4" data-id="element-246">Cada tomo incluye:</p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-[#6b5a85] font-medium" data-id="element-247">
            <span className="flex items-center gap-1.5" data-id="element-248">
              <span className="text-[#c9a14d]" data-id="element-249">✅</span> Protocolos paso a paso
            </span>
            <span className="flex items-center gap-1.5" data-id="element-250">
              <span className="text-[#c9a14d]" data-id="element-251">✅</span> Guías de sesión
            </span>
            <span className="flex items-center gap-1.5" data-id="element-252">
              <span className="text-[#c9a14d]" data-id="element-253">✅</span> Técnicas detalladas
            </span>
            <span className="flex items-center gap-1.5" data-id="element-254">
              <span className="text-[#c9a14d]" data-id="element-255">✅</span> Integración práctica
            </span>
            <span className="flex items-center gap-1.5" data-id="element-256">
              <span className="text-[#c9a14d]" data-id="element-257">✅</span> Contexto argentino
            </span>
          </div>
        </div>
      </div>
    </section>;
}